import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./sitePages.css";
import useScrollReveal from "./useScrollReveal";

function About({ embedded = false }) {
  useScrollReveal();
  return (
    <div className="content-page">
      {!embedded && <Header />}

      <main className="content-main">
        <section className="page-hero about-hero">
          <div className="about-hero-copy">
            <h1>&Agrave; propos de SAMOL TECHNOLOGIES</h1>
            <p>
              Une pr&eacute;sentation institutionnelle claire pour nos
              partenaires, clients et investisseurs.
            </p>
          </div>
          <div className="about-hero-media reveal-on-scroll" data-reveal>
            <img
              src="/Ordinateur1.jpg"
              alt="Mat&eacute;riel informatique et bureautique propos&eacute; par SAMOL TECHNOLOGIES"
              loading="lazy"
            />
          </div>
        </section>

        <section className="content-block reveal-on-scroll" data-reveal>
          <h2>Pr&eacute;sentation institutionnelle</h2>
          <p>
            SAMOL TECHNOLOGIES accompagne la transformation num&eacute;rique des
            organisations avec une approche orient&eacute;e performance,
            s&eacute;curit&eacute; et impact m&eacute;tier.
          </p>
        </section>
        <section className="content-grid">
          <article className="content-card reveal-on-scroll" data-reveal>
            <img
              className="content-card-image"
              src="/about/vision-2.avif"
              alt="Vision strat&eacute;gique de SAMOL TECHNOLOGIES"
              loading="lazy"
            />
            <h3>Notre Vision</h3>
            <p>
              Devenir un acteur de r&eacute;f&eacute;rence dans la digitalisation
              des entreprises et des &eacute;tablissements scolaires.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <img
              className="content-card-image"
              src="/about/mission-1.avif"
              alt="Mission technologique de SAMOL TECHNOLOGIES"
              loading="lazy"
            />
            <h3>Notre Mission</h3>
            <p>
              Concevoir et d&eacute;ployer des solutions technologiques fiables
              qui acc&eacute;l&egrave;rent la croissance et la qualit&eacute; de
              service de nos clients.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <img
              className="content-card-image"
              src="/about/valeurs-1.avif"
              alt="Valeurs de collaboration et d&apos;excellence"
              loading="lazy"
            />
            <h3>Nos Valeurs</h3>
            <ul>
              <li>Excellence op&eacute;rationnelle</li>
              <li>Innovation utile</li>
              <li>Transparence et confiance</li>
              <li>Orientation r&eacute;sultats</li>
            </ul>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <img
              className="content-card-image"
              src="/about/engagement premium.avif"
              alt="Engagement premium et accompagnement durable"
              loading="lazy"
            />
            <h3>Un engagement premium</h3>
            <p>
              Un suivi rigoureux, des d&eacute;lais ma&icirc;tris&eacute;s et un
              accompagnement proactif &agrave; chaque &eacute;tape de vos projets.
            </p>
          </article>
        </section>
      </main>

      {!embedded && <Footer />}
    </div>
  );
}

export default About;
